import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import {
  AlertController,
  ModalController,
  Platform,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxImageConstraints } from '@boxx/boxx-images/lib/models/BoxxImage.model';
import {
  BoxxImageFixerComponent
} from '@boxx/boxx-images';
import { StoreProfileModel } from '../../models/Store.model';
import { APP_CONSTANTS } from 'src/constants/constants';
import { STATES_DATA } from 'src/assets/statesData';
import { StorePageStore } from '@boxx/store-core';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { StatePickerComponent } from '@boxx/shared-components/lib/state-picker/state-picker.component';
import { ImageDimensionsProps } from 'src/services/ImageUtils.service';
import { PixabaySelectComponent } from '@app/pages/settings/components/pixabay-picker/pixabay-select.component';

@Component({
  selector: 'boxx-detail-form',
  templateUrl: './detail-form.component.html',
  styleUrls: ['./detail-form.component.scss'],
})
export class DetailFormComponent implements OnInit, OnDestroy {
  @Input() set store(store: StoreProfileModel) {
    this.initEmptyForm();
    if (store && store !== null) {
      this.mystore = store;
      this.patchForm(this.mystore);
    }
  }

  phoneMask = APP_CONSTANTS.PHONE_MASK;

  @Output() boxxChange = new EventEmitter<IStoreFormEmitter>();

  isCordovaOrCapacitor = false;

  mystore: StoreProfileModel;

  destroyed$ = new Subject<boolean>();

  storeForm: FormGroup;

  totalImages = 0;

  selectedImage: { id: number; src: string };

  selectedProducts: number[] = [];

  translations: any;

  imageString: string;

  defaultImage: string = 'assets/icon/LateralMenu_ProfileIcon.svg';

  @Input() set maxLogoDimensions(payload: ImageDimensionsProps) {
    this.myMaxLogoDimensions = payload;
  }

  get maxLogoDimensions() {
    return this.myMaxLogoDimensions;
  } //{ width: 600, height: 300 };

  @Input() set maxMainDimensions(payload: ImageDimensionsProps) {
    this.myMaxMainDimensions = payload;
  }
  get maxMainDimensions() {
    return this.myMaxMainDimensions;
  } //{ width: 1749, height: 1849 };

  @Input() set maxGalleryDimensions(payload: ImageDimensionsProps) {
    this.myMaxGalleryDimensions = payload;
  }
  get maxGalleryDimensions() {
    return this.myMaxGalleryDimensions;
  } // { width: 500, height: 500 };

  @Input() set maxGalleryImages(value: number) {
    this.myMaxGalleryImages = value || this.DEFAULT_MAX_GALLERY_IMAGES;
  }

  get maxGalleryImages() {
    return this.myMaxGalleryImages;
  }

  readonly DEFAULT_MAX_GALLERY_IMAGES = 1;

  private originalValues: StoreProfileModel;

  private isIos = false;
  private isNative = false;

  private myMaxLogoDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxMainDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxGalleryDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxGalleryImages = this.DEFAULT_MAX_GALLERY_IMAGES;

  constructor(
    private fb: FormBuilder,
    private alertCtrl: AlertController,
    private sanitizer: DomSanitizer,
    private storePageStore: StorePageStore,
    private boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController,
    private renderer: Renderer2,
    translate: TranslateService,
    platform: Platform
  ) {
    translate
      .get([
        'BUSINESS_FORMS',
        'STORE_MODULE',
        'IMAGES_MODULE',
        'ACTIONS',
        'ERRORS',
        'SUCCESS',
      ])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    platform.ready().then(() => {
      this.isIos = platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));

      this.isNative = platform
        .platforms()
        .some((name) => ['cordova', 'capacitor'].includes(name));

      this.isCordovaOrCapacitor =
        platform.is('cordova') || platform.is('capacitor');
    });
  }

  ngOnInit() {
    //this.phoneValidate();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initEmptyForm() {
    this.storeForm = this.fb.group({
      image: [''],
      nueva: [0],
      name: ['', Validators.required],
      //description: [''],
      closed: [false],
      phone: ['', [Validators.required]],
      companyEmail: ['', [Validators.pattern(APP_CONSTANTS.EMAILPATTERN)]],
      country: ['México'],
      state: [''],
      stateCode: [''],
      address: [''],
      companyName: [''],
      postalCode: [''],
      city: [''],
    });

    this.originalValues = this.storeForm.value;
  }

  patchForm(storeData: StoreProfileModel) {
    this.storeForm.patchValue({
      image: (storeData.generalInfo.starterSite.storeLogoUrl) ? storeData.generalInfo.starterSite.storeLogoUrl : '',
      nueva: 0,
      name: storeData.settings.storeName,
      // description: storeData.description
      //   ? this.removeHTMLInfo(storeData.description)
      //   : '',
      closed: storeData.settings.closed,
      phone: (storeData.company.phone || '').replace(/\D/g, ''),
      companyEmail: storeData.company.email,
      country: "México",
      //state: storeData.state,
      address: storeData.company.street,
      companyName: storeData.company.companyName,
      postalCode: storeData.company.postalCode,
      city: storeData.company.city,
      stateCode: storeData.company.stateOrProvinceCode
    });

    if (storeData.company.stateOrProvinceCode && storeData.company.stateOrProvinceCode !== '') {
      this.getSelectedState(storeData.company.stateOrProvinceCode);
    }

    this.originalValues = this.storeForm.value;
  }

  getSelectedState(code) {
    if (code !== undefined && code !== '' && code.length > 0) {
      const stateSel = STATES_DATA.filter((x) => x.code === code);
      if (stateSel && stateSel.length > 0) {
        this.storeForm.patchValue({
          state: stateSel[0].name,
          stateCode: stateSel[0].code
        });
      }
    }
  }

  removeHTMLInfo(value: string) {
    if (value) {
      return value.replace(/<\/?[^>]+>/gi, '');
    }
    return '';
  }

  onFieldChange() {
    if (this.imageString !== '') {
    }
    const values = this.storeForm.value;

    const hasChanges = Object.keys(values).some((key) => {
      const originalValue = this.originalValues[key];
      const newValue = this.storeForm.get(key).value;
      return newValue !== originalValue;
    });

    this.boxxChange.emit({
      hasChanges,
      data: values,
      valid: this.storeForm.valid,
    });
  }

  getFirstImage() {
    return { id: null, url: null };
  }

  async showImageOptions() {
    // Set image constraints
    // if not set or is an empty object {}, default values will be used
    // const imageConstraints: BoxxImageConstraints = {
    //   maxWidth: this.maxLogoDimensions.width,
    //   maxHeight: this.maxLogoDimensions.height,
    // };

    // // Set options for every picker
    // // if not set or is an empty object {}, default values will be used
    // const browserPickerOptions: BoxxWebBrowserPickerOptions = {
    //   // multiple: false,
    // };
    // const pickerPluginOptions: ImagePickerOptions = { quality: 75 };
    // const cameraPluginOptions: CameraOptions = { quality: 75 };

    // const picker = await this.boxxImagePickerSourceService
    //   .setImageConstraints(imageConstraints)
    //   .setPickerOptions({
    //     ...browserPickerOptions,
    //     ...pickerPluginOptions,
    //     ...cameraPluginOptions,
    //   })
    //   .showImagePickerSources();

    // this.boxxUtils.handleLoading(true);
    // let images = await picker.onSelectedValidImages();
    // this.boxxUtils.handleLoading(false);

    // // images = await this.validateAndFixImages(
    // //   images.slice(0, pickerPluginOptions.maximumImagesCount)
    // // );



    // if (!images.length && typeof (images) !== 'number') {
    //   return;
    // }

    // if (typeof (images) === 'object') {
    //   if (images.length > 0) {
    //     this.storeForm.patchValue({
    //       image: images[0].content,
    //       nueva: 1
    //     });
    //     this.onFieldChange();
    //     return;
    //   }

    //   this.onFieldChange();
    // }
    // else {
    //   images = await this.pickerFromPixaBay(imageConstraints, 1);
    //   if (!images) {
    //     return;
    //   }

    //   this.storeForm.patchValue({
    //     image: images[0].content,
    //     nueva: 1
    //   });
    //   this.onFieldChange();

    // }

  }

  async pickerFromPixaBay(imageConstraints: BoxxImageConstraints, maxImages: number) {
    const maxBytes = 5 * 1000 * 1000
    const view = await this.modalCtrl.create({
      component: PixabaySelectComponent,
      componentProps: {
        maxImages
      }
    });

    view.present();

    const { data } = await view.onDidDismiss();

    if (!data) {
      return;
    }

    let arrayImages: any[];

    arrayImages = [];
    data.pixabayImages.map((img) => {
      arrayImages.push({
        bytes: img.imageSize, //in bytes
        dimensions: {
          width: img.imageWidth,
          height: img.imageHeight,
          aspectRatio: 1
        },
        content: img.largeImageURL,
        path: img.largeImageURL,
        validations: {
          width: {
            maxWidth: imageConstraints.maxWidth,
            valid: (img.imageWidth <= imageConstraints.maxWidth) ? true : false
          },
          height: {
            maxHeight: imageConstraints.maxHeight,
            valid: (img.imageHeight <= imageConstraints.maxHeight) ? true : false
          },
          aspectRatio: {
            ratio: imageConstraints.aspectRatio,
            valid: false
          },
          bytes: {
            maxBytes: maxBytes,
            valid: (img.imageSize <= maxBytes) ? true : false
          },
          valid: false
        }
      });
    });

    if (data) {
      const view = await this.modalCtrl.create({
        component: BoxxImageFixerComponent,
        componentProps: { boxxImages: arrayImages, constraints: imageConstraints },
      });

      view.present();
      const { data } = await view.onDidDismiss();

      if (!data) {
        return;
      }

      return data.images;
    }
  }

  async openStatePicker(event: any) {

    this.boxxUtils.openBottomSheet({
      extraData: event,
      data: [],
      site: '',
      firstTimeOpen: true,
      type: BottomSheetType.states,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: 'MODALS.CUSTOM_LOCATION.state',
      maxHeigth: 80
    }).then(async (data) => {
      if (data?.value) {
        console.log('data?.value: ', data?.value);
        let _state: any = data?.value;
        this.storeForm.patchValue({
          state: _state.name,
          stateCode: _state.code
        });
        this.onFieldChange();

      }
    });

    //assdd
    // const modal = await this.modalCtrl.create({
    //component: StatePickerComponent,
    // });
    // modal.present();
    // const { data } = await modal.onDidDismiss();

    // if (data) {
    //   this.storeForm.patchValue({
    //     state: data.data.name,
    //     stateCode: data.data.code
    //   });
    //   this.onFieldChange();
    // }
  }

  //Imágenes

  getSanitizedUrl(url: string) {
    if (typeof url !== 'string') {
      return;
    }

    if (
      !url ||
      !(
        url.startsWith('http') ||
        url.startsWith('file') ||
        url.startsWith('data')
      )
    ) {
      return 'assets/icon/images.svg';
    }

    url = url.replace('unsafe:', '');

    const response = url.startsWith('file')
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
        (window as any).Ionic.WebView.convertFileSrc(url)
      )
      : this.sanitizer.bypassSecurityTrustUrl(url);

    return (response as any).changingThisBreaksApplicationSecurity || response;
  }

  showImageInContainer(data: string[]) {
    this.storeForm.patchValue({ image: data[0] });
    this.onFieldChange();
    this.imageString = data[0];
  }

  removeImage() {
    this.confirmDeleteImage();
  }

  confirmDeleteImage() {
    this.alertCtrl
      .create({
        header: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.header,
        message: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.message,
        backdropDismiss: false,
        buttons: [
          {
            text: this.translations.ACTIONS.yes,
            role: 'destructive',
            handler: () => this.deleteImage(),
          },
          { text: this.translations.ACTIONS.no },
        ],
      })
      .then((a) => a.present());
  }

  async deleteImage() {
    const storeForm = this.storeForm.value;
    if (this.mystore && storeForm.nueva === 1) {
      this.storeForm.patchValue({
        image: '',
        nueva: 0
      });
      this.onFieldChange();
    }
    else {
      this.storePageStore.configurationStore.deleteImageProfile(0);
    }
  }

  phoneValidate() {
    const phoneControl: AbstractControl = this.storeForm.controls['phone'];

    phoneControl.valueChanges.subscribe(data => {

      /**the most of code from @Günter Zöchbauer's answer.*/

      /**we remove from input but: 
         @preInputValue still keep the previous value because of not setting.
      */
      let preInputValue: string = this.storeForm.value.phone;
      var lastChar: string = preInputValue.substr(preInputValue.length - 1);
      // remove all mask characters (keep only numeric)
      var newVal = data.replace(/\D/g, '');

      let start = this.renderer.selectRootElement('#tel').selectionStart;
      let end = this.renderer.selectRootElement('#tel').selectionEnd;
      //let start=this.phoneRef.nativeElement.selectionStart;
      //let end = this.phoneRef.nativeElement.selectionEnd;
      //when removed value from input
      if (data.length < preInputValue.length) {
        //this.message = 'Removing...'; //Just console
        /**while removing if we encounter ) character,
          then remove the last digit too.*/
        if (preInputValue.length < start) {
          if (lastChar == ')') {
            newVal = newVal.substr(0, newVal.length - 1);
          }
        }
        //if no number then flush
        if (newVal.length == 0) {
          newVal = '';
        }
        else if (newVal.length <= 3) {
          /**when removing, we change pattern match.
          "otherwise deleting of non-numeric characters is not recognized"*/
          newVal = newVal.replace(/^(\d{0,3})/, '($1');
        } else if (newVal.length <= 6) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
        }

        this.storeForm.controls['phone'].setValue(newVal, { emitEvent: false });
        //keep cursor the normal position after setting the input above.
        this.renderer.selectRootElement('#tel').setSelectionRange(start, end);
        //when typed value in input
      } else {
        //this.message = 'Typing...'; //Just console
        var removedD = data.charAt(start);
        // don't show braces for empty value
        if (newVal.length == 0) {
          newVal = '';
        }
        // don't show braces for empty groups at the end
        else if (newVal.length <= 3) {
          newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if (newVal.length <= 6) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
        }
        //check typing whether in middle or not
        //in the following case, you are typing in the middle
        if (preInputValue.length >= start) {
          //change cursor according to special chars.
          console.log(start + removedD);
          if (removedD == '(') {
            start = start + 1;
            end = end + 1;
          }
          if (removedD == ')') {
            start = start + 2; // +2 so there is also space char after ')'.
            end = end + 2;
          }
          if (removedD == '-') {
            start = start + 1;
            end = end + 1;
          }
          if (removedD == " ") {
            start = start + 1;
            end = end + 1;
          }
          this.storeForm.controls['phone'].setValue(newVal, { emitEvent: false });
          this.renderer.selectRootElement('#tel').setSelectionRange(start, end);
        } else {
          this.storeForm.controls['phone'].setValue(newVal, { emitEvent: false });
          this.renderer.selectRootElement('#tel').setSelectionRange(start + 2, end + 2); // +2 because of wanting standard typing
        }
      }
    });
  }


  validaTelefono(event) {
    event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    this.storeForm.patchValue({
      phone: event.target.value.substring(0, 10),
    });
  }

  validaTelefonoChange(event) {
    event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    event.target.value = event.target.value.substring(0, 10);
    this.storeForm.patchValue({
      phone: event.target.value.substring(0, 10),
    });
    this.onFieldChange()
  }

}
//Imágenes

export interface IStoreFormEmitter {
  hasChanges: boolean;
  data: any;
  valid: boolean;
}
